<template>
        <!-- login section -->
    <section class="login-page">
        <div class="container">
            <div class="login">
                <h1 class="heading-title text-center">Login</h1>
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-8 col-lg-6">
                        <form>
                            <div class="form-row justify-content-center align-items-center">
                                <div class="form-group col-md-10">
                                    <label for="email" class="required">Email</label>
                                    <input type="email" class="form-control input" id="email" placeholder="Email" v-model="user.email">
                                </div>
                                <div class="form-group col-md-10">
                                    <label for="passwoed" class="required">Password</label>
                                    <input type="password" class="form-control input" id="passwoed"
                                        placeholder="Password" v-model="user.password">
                                </div>
                                <div class="form-group col-md-10 d-flex justify-content-between align-items-center">
                                    <label class="d-flex justify-content-between align-items-center custom-checkbox">
                                        <input type="checkbox" name="shipping" value="2">
                                        <span class="icon rounded"><i class="fas fa-check"></i></span>
                                        <span>Remember me</span>
                                    </label>
                                    <a href="#" class="forgot-password">Forgot Password?</a>
                                </div>
                                <div class="form-group col-md-10">
                                    <button type="button" class="btn main-btn w-100" @click="signIn">Login</button>
                                </div>

                                <div class="form-group col-md-6 d-flex justify-content-between flex-wrap">
                                    <a href="#" class="btn login-link facebook">facebook</a>
                                    <a href="#" class="btn login-link google">Google</a>
                                    <div class="w-100 text-center new-account">New account? <a href="#">Register</a>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="col-lg-6 d-none d-lg-block">
                        <div class="image">
                            <img src="@/assets/app/images/login.png" alt="login-image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--end login section -->
</template>

<script>
import "../../sass/login.scss";
export default {
    name: "login",
    data() {
        return {
            user: {
                email: "ahmed@gmail.com",
                password: "123456"
            }
        }
    },
    computed: {
        auth() {
             return this.$store.getters["authModule/getUser"];
        }
    },
    methods: {
        signIn() {
            this.$store.dispatch("authModule/signIn", this.user);
        }
    },
    watch: {
        auth(value) {
            value ? this.$router.push("/") : "";
        }
    }
}
</script>
